import { render, staticRenderFns } from "./purchaseProjectTable.vue?vue&type=template&id=b3f300d0&scoped=true&"
import script from "./purchaseProjectTable.vue?vue&type=script&lang=js&"
export * from "./purchaseProjectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f300d0",
  null
  
)

export default component.exports